<template>
  <div class="info-wrapper">
    <img class="info-wrapper" :src="textData.img">
    <div ref="move" :class="moveClass">
      <div class="data_p">
        <h2>{{textData.title}}</h2>
        <p class="fnt_24">{{textData.content}}</p>
      </div>
      <div class="news-info">
        <el-carousel height="50vh" arrow="always" :interval="5000" indicator-position="none"
                     :autoplay="false"
                     :loop="false">
          <el-carousel-item :key="index" v-for="(item, index) in newList">
            <div class="infos-row">
              <div class="child-item" v-for="(child, childIndex) in item" :key="childIndex">
                <img :src="child.img"/>
                <h2 class="fnt-title">{{child.title}}</h2>
                <!--                <div class="fnt_24 fnt-content" v-html="child.content"></div>-->
              </div>
            </div>
          </el-carousel-item>
          <!--          <el-carousel-item key="1">-->
          <!--            <div class="infos-row">-->
          <!--              <div class="child-item">-->
          <!--                <img src="../../../static/images/firstPage/serviceCustomer.png"/>-->
          <!--                <h2 class="fnt-title">沈阳蓝智科技受邀参加年度中国国际智能传播理论联系十论联系十</h2>-->
          <!--                <p class="fnt_24 fnt-content">2023年9月，以“大模型AI技术在传媒行业的应用与挑战”为主题的2023年中国国际智能传播理论得意推广与进行</p>-->
          <!--              </div>-->
          <!--              <div class="child-item">-->
          <!--                <img src="../../../static/images/firstPage/bigDataService.png"/>-->
          <!--                <h2 class="fnt-title">沈阳蓝智科技受邀参加年度中国国际智能传播理论联系十</h2>-->
          <!--                <p class="fnt_24 fnt-content">2023年9月，以“大模型AI技术在传媒行业的应用与挑战”为主题的2023年中国国际智能传播理论得意推广与进行</p>-->
          <!--              </div>-->
          <!--              <div class="child-item">-->
          <!--                <img src="../../../static/images/firstPage/serviceCustomer.png"/>-->
          <!--                <h2 class="fnt-title">沈阳蓝智科技受邀参加年度中国国际智能传播理论联系十</h2>-->
          <!--                <p class="fnt_24 fnt-content">2023年9月，以“大模型AI技术在传媒行业的应用与挑战”为主题的2023年中国国际智能传播理论得意推广与进行</p>-->
          <!--              </div>-->
          <!--              <div class="child-item">-->
          <!--                <img src="../../../static/images/firstPage/serviceCustomer.png"/>-->
          <!--                <h2 class="fnt-title">沈阳蓝智科技受邀参加年度中国国际智能传播理论联系十</h2>-->
          <!--                <p class="fnt_24 fnt-content">2023年9月，以“大模型AI技术在传媒行业的应用与挑战”为主题的2023年中国国际智能传播理论得意推广与进行</p>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </el-carousel-item>-->
        </el-carousel>
        <el-button @click="routerTo(textData.link)">
          了解更多内容
          <i class="el-icon-caret-right el-icon--right"></i>
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        moveClass: 'big-data-text move-before',
        textData: {},
        contentData: [],
        newList: []
      }
    },
    methods: {
      routerTo (route) {
        this.$router.push({
          path: route,
          query: ''
        })
      },
      // 定义一个辅助函数，用于切片数组
      sliceIntoChunks (array, chunkSize) {
        return array.reduce((chunks, item, index) => {
          const chunkIndex = Math.floor(index / chunkSize);
          if (!chunks[chunkIndex]) {
            chunks[chunkIndex] = [];
          }
          chunks[chunkIndex].push(item);
          return chunks;
        }, []);
      }
    },
    mounted: function () {
      if (this.$boss) {
        this.textData = this.$boss.page161.g161[0]
        this.contentData = [...this.$boss.page412.g412].reverse() || []
        this.newList = []
        for (let i = 0; i < this.contentData.length; i += 4) {
          this.newList.push(this.contentData.slice(i, i + 4))
        }
        let arr = []
        this.newList.forEach(i => {
          i.forEach(j => {
            arr.push(j)
          })
        })
        this.newList = arr
        this.newList.reverse()
        this.newList = this.sliceIntoChunks(this.newList, 4)
        // console.log('this.newList', this.newList)
      }
    }
  }
</script>
<style scoped lang="less">
  .info-wrapper {
    width: 100%;
    height: 100%;
    /*background: url("../../../static/images/firstPage/newsInfo.png") no-repeat;*/
    background-size: 100% 100%;
  }
  @media screen and (max-width: 1900px) {
    .data-text {
      color: #fff;
      position: absolute;
      left: 200px;
      top: 15%;
      text-align: left;
      width: 100%;
      z-index: 999;
      transition: all 1.5s;
      -webkit-transition: all 1.5s;
    }
    .move-before{
      transform: translate(0,-50%);
      -webkit-transform: translate(0,-50%);
      -ms-transform: translate(0,-50%);
      opacity: 0;

    }

    .move-after{
      transform: translate(-100px,-50%);
      -webkit-transform: translate(-100px,-50%);
      -ms-transform: translate(-100px,-50%);
      opacity: 1;
    }

    .data_p {
      flex: 1
    }
    .data_p h2, .data_p p {
      display: -webkit-box;
      overflow: hidden;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .data_p p {
      font-size: 24px;
    }
    .data_p h2 {
      font-size: 36px;
      margin-bottom: 15px;
      line-height: 60px;
      max-height: 120px;
    }

    .news-info {
      position: absolute;
      width: 88%;
      top: 100%;
      .el-carousel {
        width: 100%;
      }
      /deep/ .infos-row {
        display: flex;
        /*justify-content: space-between;*/
        /*margin-left: 5%;*/
        .child-item{
          margin-right: 2%;
          width: 23%;
          height: 50vh;
          background-color: rgb(255, 255, 255);
          /*border: 1px solid #13ce66;*/
          img {
            width: 100%;
            height: 20vh;
          }
          img:hover {
            transform: scale(1.02);
          }
          h2 {
            font-size: 24px;
            /*line-height: 36px;*/
            font-weight: 500;
            padding: 0 15px;
            color: black;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
          p{
            font-size: 18px;
            color: #7b7c80;
            padding: 0 15px;
            line-height: 24px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
          }
        }
      }
      /*/deep/ .el-carousel__arrow--left {*/
      /*  background: url("../../../static/images/firstPage/icon/left.png");*/
      /*}*/
      /*/deep/ .el-carousel__arrow--right {*/
      /*  background: url("../../../static/images/firstPage/icon/right.png");*/
      /*}*/
    }
    .el-button {
      margin-top: 2vh;
      color: #fa6e1a;
      background-color: transparent;
      border: 1px solid #fa6e1a;
      font-size: 18px;
    }
  }
  @media screen and (min-width: 1901px) {
    .data-text {
      color: #fff;
      position: absolute;
      left: 200px;
      top: 12%;
      text-align: left;
      width: 100%;
      z-index: 999;
      transition: all 1.5s;
      -webkit-transition: all 1.5s;
    }
    .move-before{
      transform: translate(0,-50%);
      -webkit-transform: translate(0,-50%);
      -ms-transform: translate(0,-50%);
      opacity: 0;

    }

    .move-after{
      transform: translate(-100px,-50%);
      -webkit-transform: translate(-100px,-50%);
      -ms-transform: translate(-100px,-50%);
      opacity: 1;
    }

    .data_p {
      flex: 1
    }
    .data_p h2, .data_p p {
      display: -webkit-box;
      overflow: hidden;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .data_p p {
      font-size: 24px;
    }
    .data_p h2 {
      font-size: 42px;
      margin-bottom: -15px;
      line-height: 60px;
      max-height: 120px;
    }

    .news-info {
      position: absolute;
      width: 90%;
      top: 120%;
      .el-carousel {
        width: 100%;
      }
      /deep/ .infos-row {
        display: flex;
        /*justify-content: space-between;*/
        /*margin-left: 5%;*/
        .child-item{
          margin-right: 2%;
          width: 23%;
          height: 50vh;
          background-color: rgb(255, 255, 255);
          /*border: 1px solid #13ce66;*/
          img {
            width: 100%;
            height: 30vh;
          }
          img:hover {
            transform: scale(1.02);
          }
          h2 {
            font-size: 24px;
            font-weight: 500;
            line-height: 36px;
            padding: 6px 36px;
            color: black;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
          p{
            font-size: 20px;
            color: #7b7c80;
            padding: 0 36px;
            line-height: 36px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
          }
        }
      }
      /*/deep/ .el-carousel__arrow--left {*/
      /*  background: url("../../../static/images/firstPage/icon/left.png");*/
      /*}*/
      /*/deep/ .el-carousel__arrow--right {*/
      /*  background: url("../../../static/images/firstPage/icon/right.png");*/
      /*}*/
    }
    .el-button {
      margin-top: 4vh;
      color: #fa6e1a;
      background-color: transparent;
      border: 1px solid #fa6e1a;
      font-size: 18px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/components/newsInfo.vue